import React from 'react';
import Icon from './Icon';

export default () => {
    return (
        <div className="leaflet-rule text-secondary">
            <Icon.Ring/>
        </div>
    )
}
